import { render, staticRenderFns } from "./NewEstateHouseType.vue?vue&type=template&id=27a3664c&scoped=true&"
import script from "./NewEstateHouseType.vue?vue&type=script&lang=js&"
export * from "./NewEstateHouseType.vue?vue&type=script&lang=js&"
import style0 from "./NewEstateHouseType.vue?vue&type=style&index=0&id=27a3664c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a3664c",
  null
  
)

export default component.exports